export default "__VITE_ASSET__D_Kw_Tmt__"